export const mainMenu = {
    displayMenu: {
        default: {
            level0: [
                /* concours to activate if there is some one{
                    name: 'contests',
                    onlyForLocalizations: ['fr'],
                },*/
                'achievement',
                'onlyModels',
                {
                    'name': 'followed-tab',
                    'translate': {
                        'parent': {
                            learner: 'assignment.title_my_activity',
                            default: 'assignment.title'
                        },
                    },
                    icon: 'assignation',
                },
                {
                    name: 'forFurther',
                    children: [
                        'gameCodeList',
                        'gleamCodeList',
                    ],
                },
                'gamification',
                {
                    name: 'how-to',
                    onlyForLocalizations: ['fr'],
                },
                'iackathon-intro-learner',
                'access-future-engineer',
                {
                    name: 'contact-us',
                    class: ['menu-break'],
                },
                'mentions-legales',
                'cgurgpd',
                'politique-confidentialite',
                'accessibility',
                'site-map',
            ],
        },
        trainer: {
            level0: [
                'home',
               /* { concours to activate when have someone
                    name: 'contests',
                    onlyForLocalizations: ['fr'],
                },*/
                'onlyModels',
                {
                    'name': 'parameter',
                    'children': ['param-child-groups', 'param-child-workgroups', 'param-child-learners'],
                    'translate': {
                        'parent': {
                            learner: 'generic.my_classes_learner',
                            default: 'navigation.groups-management'
                        },
                        'childs': {
                            'param-child-groups': {
                                learner: 'generic.my_class',
                                default: 'groups-management.classes'
                            },
                            'param-child-workgroups': {
                                learner: 'generic.my_workgroups',
                                default: 'groups-management.workgroups',
                            },
                        }
                    }
                },
                {
                    'name': 'followed-tab',
                    'translate': {
                        'parent': {
                            learner: 'assignment.title_my_activity',
                            default: 'assignment.title'
                        }
                    }
                },
                {
                    name: 'forFurther',
                    children: [
                        'gameCodeList',
                        'gleamCodeList',
                    ],
                },
                'iackathon-intro',
                'access-future-engineer',
                'contact-us',
                'mentions-legales',
                'cgurgpd',
                'politique-confidentialite',
                'accessibility',
                'site-map',
            ],
        },
    },
};